import { ORIGIN } from "@supplier/meta";
import httpRequest from "./index";

import type { CaptchaLoginForm, MeVo, PcAccountLoginForm, Session } from "@supplier/entity";

const PATH = "/login";
const service = httpRequest;
/** 登录页接口错误由表单局部展示，避免请求层弹出全局 Message */
const loginLocalErrorConfig = { skipGlobalErrorMessage: true };

/**
 * 账号登录
 */
export const accountLogin = async (params: PcAccountLoginForm): Promise<Session> => {
    const { data } = await service.post(`${PATH}/pc/account`, params, loginLocalErrorConfig);
    return data;
};

/**
 * 验证码登录
 */
export const login = async (params: CaptchaLoginForm) => {
    return service.post(`${PATH}/pc`, params, loginLocalErrorConfig);
};

export const getMe = async (): Promise<MeVo> => {
    const { data } = await service.get(`${PATH}/me`);
    return data;
};

export const logout = async () => {
    const { data } = await service.get("/logout");
    return data;
};

// 切换代理账号
export const loginSwitchProxy = async (proxyAccountId: number, mainBodyId?: number) => {
    let params = `proxyAccountId=${proxyAccountId}&origin=${ORIGIN.PC.code}`;
    if (mainBodyId) {
        params += `&mainBodyId=${mainBodyId}`;
    }
    const { data } = await service.put(`${PATH}/switch/proxy?${params}`);
    return data;
};

// 切换主体
export const loginSwitchMainBody = async (mainBodyId: number) => {
    let params = `origin=${ORIGIN.PC.code}`;
    if (mainBodyId) {
        params += `&mainBodyId=${mainBodyId}`;
    }
    const { data } = await service.put(`${PATH}/switch/main-body?${params}`);
    return data;
};
